import bus from "@zalando-internal/z-shop-event-bus";
import safeFetch from "safe-fetch";

// Define types
interface FetchOptions extends RequestInit {
  reportChildRequestId?: boolean;
}

// Configure safe-fetch
safeFetch.cookieName = "frsx";
safeFetch.headerName = "x-xsrf-token";

export default function extendedFetch(
  url: string,
  optionalOptions?: FetchOptions,
): Promise<Response> {
  const options: FetchOptions = {
    reportChildRequestId: true,
    ...optionalOptions,
  };

  return safeFetch(url, options).then((response: Response) => {
    if (
      response &&
      response.headers &&
      response.headers.get &&
      options.reportChildRequestId
    ) {
      bus.trigger(
        "tracking:child-request-id",
        response.headers.get("x-zalando-child-request-id"),
        url,
        options,
      );
    }
    return response;
  });
}
